import { FormEvent, useState } from "react";
import { useAuth } from "../context/AuthContext";

export function LoginPanel() {
  const { errorMessage, isConfigured, isLoading, resetPassword, signIn } =
    useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [notice, setNotice] = useState<string | null>(null);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setNotice(null);
    await signIn(email, password);
  }

  async function handleResetPassword() {
    setNotice(null);
    await resetPassword(email);
    setNotice("Si le compte existe, un email de réinitialisation a été envoyé.");
  }

  return (
    <main className="auth-shell">
      <section className="auth-panel" aria-labelledby="login-title">
        <div>
          <p className="eyebrow">Qorelia Formation</p>
          <h1 id="login-title">Administration des formations</h1>
          <p className="lead">
            Accès réservé aux administrateurs et formateurs habilités.
          </p>
        </div>

        {!isConfigured ? (
          <div className="alert alert-warning" role="status">
            La configuration Firebase est incomplète. Renseignez les variables
            `VITE_FIREBASE_*` avant de connecter l'application.
          </div>
        ) : null}

        <form className="stack" onSubmit={handleSubmit}>
          <label className="field">
            <span>Email administrateur</span>
            <input
              autoComplete="email"
              disabled={!isConfigured || isLoading}
              inputMode="email"
              onChange={(event) => setEmail(event.target.value)}
              required
              type="email"
              value={email}
            />
          </label>

          <label className="field">
            <span>Mot de passe</span>
            <input
              autoComplete="current-password"
              disabled={!isConfigured || isLoading}
              minLength={8}
              onChange={(event) => setPassword(event.target.value)}
              required
              type="password"
              value={password}
            />
          </label>

          {errorMessage ? (
            <div className="alert alert-error" role="alert">
              {errorMessage}
            </div>
          ) : null}

          {notice ? (
            <div className="alert alert-info" role="status">
              {notice}
            </div>
          ) : null}

          <div className="actions">
            <button
              className="button button-primary"
              disabled={!isConfigured || isLoading}
              type="submit"
            >
              {isLoading ? "Connexion..." : "Se connecter"}
            </button>
            <button
              className="button button-secondary"
              disabled={!isConfigured || isLoading || !email}
              onClick={handleResetPassword}
              type="button"
            >
              Réinitialiser
            </button>
            <a className="button button-secondary" href="#/">
              Accueil participant
            </a>
          </div>
        </form>
      </section>
    </main>
  );
}
